import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export const AdminIndexRedirect: React.FC = () => {
  const { currentUser } = useAuth();
  
  // 閲覧者の場合はサイト一覧、それ以外はダッシュボード
  const redirectPath = currentUser?.role === 'viewer' ? '/admin/sites' : '/admin/dashboard';
  
  return <Navigate to={redirectPath} replace />;
};






